import { Skeleton } from 'antd'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { QuestionCircleOutlined } from '@ant-design/icons'

import { useStore } from 'store/useStore'
import { PickPointType } from 'sections/LKSection/shared/PickPointSharedModule/types'
import { Button, Flex, Text } from 'components/uiKit'
import { useAsyncEffect } from 'utils/hooks/useAsyncEffect'
import { URLS } from 'shared/constants/urls'
import { Country } from 'shared/types/types'

import { OrderStatus } from '../../types'

import s from './Tariff.module.scss'

type TariffProps = {
  latitude: number
  longitude: number
  area: number
  typePoint: PickPointType
  status?: OrderStatus
  tariffDescription?: string[]
}

export const Tariff = observer(
  ({ latitude, longitude, area, typePoint, status = OrderStatus.draft, tariffDescription = [''] }: TariffProps) => {
    const { createOrderUiStore: uiStore, appStore } = useStore()

    const [tariffs, setTariffs] = useState<string>('')
    const [tariffsLoading, setTariffsLoading] = useState(false)

    const tariffFromRequest = status === OrderStatus.draft
    const tariffDescriptionString = tariffDescription?.[0] ?? ''
    const country = appStore.companyCountry

    useAsyncEffect(async () => {
      if (tariffFromRequest && latitude && longitude) {
        setTariffsLoading(true)

        const data = {
          lat: parseFloat(latitude.toString()),
          lon: parseFloat(longitude.toString()),
          area: parseFloat(area.toString()),
          typePoint,
        }

        const res = await uiStore.getTariffs(data)

        setTariffs(res ?? '')
        setTariffsLoading(false)
      } else {
        setTariffs(tariffDescriptionString)
        const tariffString = tariffDescriptionString.split(' ')

        for (const word of tariffString) {
          if (word.includes('%')) {
            uiStore.setTariff(+word.slice(0, word.length - 1))
          }
        }
      }
    }, [])

    return (
      <Flex>
        {tariffsLoading ? (
          <Skeleton.Input active={true} size="small" />
        ) : (
          tariffs?.length > 0 && (
            <Flex align="center" gap={8}>
              <Text className={s.tariff} style={{ color: 'var(--corp)' }}>
                {tariffs}
              </Text>

              {country !== Country.GE && (
                <Button
                  shape="circle"
                  icon={<QuestionCircleOutlined />}
                  type="link"
                  href={URLS.tariffs}
                  target="_blank"
                />
              )}
            </Flex>
          )
        )}
      </Flex>
    )
  },
)
